import React from 'react';
import {Select as NBSelect, ISelectProps, ISelectItemProps} from 'native-base';

export const SelectItem = (props: ISelectItemProps) => {
  return(
    <NBSelect.Item {...props} ></NBSelect.Item>
  )
} 

export const SelectGroup = (props: ISelectProps) => {
  return(
    <NBSelect {...props}>
    </NBSelect>
  )
}